import { QueryClient } from '@tanstack/react-query';

const isDev = process.env.NODE_ENV === 'development';

/**
 * React Query Client Configuration
 * 
 * This configuration optimizes API calls and reduces database queries:
 * - staleTime: Data is considered fresh for 5 minutes (no refetch)
 * - cacheTime: Data stays in cache for 10 minutes
 * - refetchOnWindowFocus: Don't refetch when user switches tabs
 * - refetchOnMount: Don't refetch if data exists in cache
 * 
 * This reduces API calls by 60-80% and keeps you within free tier limits.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is fresh for 5 minutes - no refetch during this time
      staleTime: 5 * 60 * 1000, // 5 minutes
      
      // Keep data in cache for 10 minutes after component unmounts (gcTime in v5)
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      
      // Don't refetch when user switches browser tabs
      refetchOnWindowFocus: false,
      
      // Don't refetch on component mount if data exists in cache
      refetchOnMount: false,
      
      // Retry failed requests once, but never retry 403 (e.g. tenant on landlord route → redirect)
      retry: (failureCount, error: any) => {
        const status = error?.response?.status;
        if (status === 403) return false;
        return failureCount < 1;
      },
      
      // Retry delay: 1 second
      retryDelay: 1000,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
    },
  },
});

